<template>
  <div>
    <div class="links-title">{{ label || "Links" }}</div>
    <v-btn
      @click="addLink()"
      small
      text
      outlined
      :disabled="block.hasOwnProperty('disableInputs')"
    >
      Add link
      <v-icon v-text="'mdi-plus'"></v-icon>
    </v-btn>
    <div class="mt-2">
      <draggable
        tag="div"
        :list="links"
        handle=".handle2"
        @end="saveBlockConfig(block)"
        ghostClass="ghost"
        :disabled="block.hasOwnProperty('disableInputs')"
      >
        <LinkBuilderItem
          v-for="(link, index) in links"
          :key="link.id"
          :link="link"
          :block="block"
          :label="label"
          :fullpath="fullpath"
          :index="index"
        >
        </LinkBuilderItem>
      </draggable>
    </div>
  </div>
</template>

<script>
import LinkBuilderItem from "./LinkBuilderItem";
import projectMixin from "../project-mixin";

export default {
  components: { LinkBuilderItem },
  mixins: [projectMixin],
  props: ["links", "block", "label", "fullpath"],
  data() {
    return {
      stripeConfigDialog: false,
      showPagesMenu: false,
      x: 0,
      y: 0,
    };
  },
  methods: {
    addLink() {
      const item = {
        id: this.randomId(),
        href: "/",
        text: "Link",
        isNewTab: false,
        showArrow: false,
        enableArrowAnimation: false,
        isButton: false,
        activateStripe: false,
        isOutlined: false,
        isShadowed: false,
        small: false,
        stripeConfig: {
          productId: "",
          planId: "",
          successUrl: "",
          cancelUrl: "",
          publishableApiKey: "",
        },
        executeScript: false,
        script: null,
      };
      this.ADD_BLOCK_LIST_ITEM({
        id: this.block.id,
        prop: this.fullpath,
        item,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.links-title {
  font-size: 15px;
  font-weight: bold;
}

.page {
  margin-top: 2px;
  cursor: pointer;
  padding: 0px 4px;

  &:hover {
    background-color: #ececec;
  }
}
</style>